export default "__VITE_ASSET__BFhYrUrZ__"